var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.118,
    height: 22.088,
    viewBox: "0 0 22.118 22.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6358088_bubble_chat_conversation_inbox_message_icon",
    "data-name": "6358088_bubble_chat_conversation_inbox_message_icon",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M15.789,29.14a.789.789,0,1,1,0-1.577A9.463,9.463,0,0,0,20.859,26.1a.789.789,0,1,1,.844,1.325A10.961,10.961,0,0,1,15.789,29.14Z",
    transform: "translate(-2.749 -5.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M26.788,22.042a.789.789,0,0,1-.67-1.207,9.463,9.463,0,0,0,1.459-5.047.789.789,0,1,1,1.577,0,11.04,11.04,0,0,1-1.7,5.883A.789.789,0,0,1,26.788,22.042Z",
    transform: "translate(-5.074 -2.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M13.04,24.08A11.04,11.04,0,1,1,24.08,13.04a.789.789,0,0,1-1.577,0A9.463,9.463,0,1,0,13.04,22.5a.789.789,0,1,1,0,1.577Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M27.519,29.154a.986.986,0,0,1-.252-.039l-4.731-1.577a.791.791,0,0,1,.5-1.5l4.731,1.577a.784.784,0,0,1-.252,1.538Z",
    transform: "translate(-4.228 -5.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M28.365,28.308a.789.789,0,0,1-.749-.536L26.039,23.04a.791.791,0,0,1,1.5-.5l1.577,4.731a.789.789,0,0,1-.5,1.041A.985.985,0,0,1,28.365,28.308Z",
    transform: "translate(-5.074 -4.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M15.577,17.154a1.577,1.577,0,1,1,1.577-1.577A1.577,1.577,0,0,1,15.577,17.154Zm0-1.577Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Z",
    transform: "translate(-2.537 -2.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M22.577,17.154a1.577,1.577,0,1,1,1.577-1.577A1.577,1.577,0,0,1,22.577,17.154Zm0-1.577Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Z",
    transform: "translate(-4.017 -2.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M8.577,17.154a1.577,1.577,0,1,1,1.577-1.577A1.577,1.577,0,0,1,8.577,17.154Zm0-1.577Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Z",
    transform: "translate(-1.057 -2.537)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/Conversation.6530386dc1bfb9cf27da737f93db9129.svg";
export { ForwardRef as ReactComponent };